/**
 * MedsSummaryStrip — общ брояч „лекарства, добавки и билки" с връзка към списъка.
 * Данни: GET /api/medications/summary
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Pill, Leaf, FlaskConical, Clock, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MedsSummaryStrip({ cardCls, isDark }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/medications/summary`)
      .then(({ data }) => setData(data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const base = cardCls || (isDark
    ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200");
  const c = data.counts || {};

  return (
    <button onClick={() => navigate("/dashboard/medications")}
      className={`w-full text-left p-3.5 rounded-2xl border ${base}
                  hover:border-violet-500/50 transition-colors`}
      data-testid="meds-summary-strip">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-4 flex-wrap">
          <span className="text-[12px] font-bold inline-flex items-center gap-1.5">
            <Pill className="w-4 h-4 text-violet-500" /> Моят списък
          </span>
          <span className="text-[11px] inline-flex items-center gap-1">
            <Pill className="w-3 h-3 text-violet-500" /> {c.drug || 0} лекарства
          </span>
          <span className="text-[11px] inline-flex items-center gap-1">
            <FlaskConical className="w-3 h-3 text-sky-500" /> {c.supplement || 0} добавки
          </span>
          <span className="text-[11px] inline-flex items-center gap-1">
            <Leaf className="w-3 h-3 text-emerald-500" /> {c.herbal || 0} билки
          </span>
          {!!data.with_schedule && (
            <span className="text-[11px] inline-flex items-center gap-1 opacity-70">
              <Clock className="w-3 h-3" /> {data.with_schedule} с часове
            </span>
          )}
        </div>
        <ArrowRight className="w-4 h-4 opacity-40" />
      </div>
      {!data.total && (
        <div className="text-[10px] opacity-60 mt-1" data-testid="meds-summary-empty">
          Списъкът е празен — добавете лекарствата и добавките си в профила,
          за да работят проверките навсякъде.
        </div>
      )}
    </button>
  );
}
